export const getLoginErrorReason = (error) => {
  return error?.graphQLErrors?.[0]?.extensions?.exception?.reason;
};
